module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="383" height="173" viewBox="0 0 383 173"><path d="M93.75 94.286V70.714H70.312v23.572H93.75zm70.313 0V70.714h-23.438v23.572h23.438zm70.312 0V70.714h-23.438v23.572h23.438zm70.313 0V70.714H281.25v23.572h23.438zM70.313 165v-23.571H46.874v-23.572H0V94.286h23.438V70.714h23.437V47.143h23.438V23.57h46.874V0h140.625v23.571h46.875v23.572h23.438v23.571h23.438v23.572H375v23.571h-46.875v23.572h-23.438V165H281.25v-23.571h-23.438v-23.572h-46.875v23.572h-46.875v-23.572h-46.875v23.572H93.75V165H70.312z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_about_us_alien_giant.svg
// module id = 1797
// module chunks = 4